import { createSlice } from '@reduxjs/toolkit';

export const POPUP_TYPES = {
  empty: '',
  addRFID: 'addRFID',
  deleteRFID: 'deleteRFID',
  logout: 'logout',
  changeAccountPassword: 'changeAccountPassword'
};

const initialState = {
  popupType: POPUP_TYPES.empty
};

const setError = (state, action) => {
  state.errorMessage = action.payload;
};

export const popupSlice = createSlice({
  name: '@@popup',
  initialState,
  reducers: {
    SET_ACCESS_ERROR: setError,
    POPUP_TYPE_EMPTY: (state, action) => {
      state.popupType = POPUP_TYPES.empty;
      state.errorMessage = null;
      state.popuptypeData = {
        ...(state.popuptypeData || {}),
        type: action.payload
      };
    },
    POPUP_TYPE_LOGOUT: (state, action) => {
      state.popupType = POPUP_TYPES.logout;
      state.errorMessage = null;
      state.popuptypeData = {
        ...(state.popuptypeData || {}),
        type: action.payload
      };
    },
    POPUP_TYPE_CHANGE_ACCOUNT_PASSWORD: (state, action) => {
      state.popupType = POPUP_TYPES.changeAccountPassword;
      state.errorMessage = null;
      state.popuptypeData = {
        ...(state.popuptypeData || {}),
        type: action.payload
      };
    }
  },
  extraReducers: {}
});

export const {
  POPUP_TYPE_EMPTY,
  SET_ACCESS_ERROR,
  POPUP_TYPE_LOGOUT,
  POPUP_TYPE_CHANGE_ACCOUNT_PASSWORD
} = popupSlice.actions;

export default popupSlice.reducer;
